<template>

	<div>
		<div v-if="shouldDisplay" class="add_mobile">
			<add-to-cart
				:product="item"
				:product-code="item.code"
				type="shop">
			</add-to-cart>
		</div>

		<div class="icons_wrapp" v-if="shouldDisplay">
			<div class="icons"
			     x-show="animate" x-transition:enter-start="icons_enter_start"
			     x-transition:enter-end="icons_enter_end" x-transition:leave-start="icons_enter_end"
			     x-transition:leave-end="icons_enter_start"
			>

				<add-to-cart
					:product="item"
					:product-code="item.code"
					type="shop">
				</add-to-cart>

			</div>
		</div>

	</div>
</template>

<script>
export default {
	name: "CategoryCart",

	props: [
		'item'
	],

	computed: {

		/**
		 *  Resolve if add to cart button should be previewed based on items brand.
		 *
		 * @returns {string}
		 */
		shouldDisplay() {
			if (this.item.brandTitle === 'YOKO London') {
				return false;
			} else if (this.item.brandTitle === 'Zlatara JOKIĆ') {
				return false;
			} else if (this.item.brandTitle === 'Burato') {
				return false;
			} else {
				return true;
			}
		}
	},

}

</script>

